/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'ssl-ciphers-grid';
const prefix = `${moduleName}.${componentName}`;

export const enabledLabel = `${prefix}.enabledLabel`;
export const cipherLabel = `${prefix}.cipherLabel`;
export const securityScoreLabel = `${prefix}.securityScoreLabel`;
export const pfsLabel = `${prefix}.pfsLabel`;
export const performanceLabel = `${prefix}.performanceLabel`;
export const compatibilityLabel = `${prefix}.compatibilityLabel`;

export const ENGLISH = {
    [enabledLabel]: 'Enabled',
    [cipherLabel]: 'Cipher',
    [securityScoreLabel]: 'Security Score',
    [pfsLabel]: 'PFS',
    [performanceLabel]: 'Performance',
    [compatibilityLabel]: 'Compatibility',
};
